module.exports = __webpack_public_path__ + "img/wh_settlement_schematic.1e732afe.png";